import React, { useState, useMemo, useEffect } from 'react';
import { OntotisDropDown, Person } from '../../../utils/types';
import { CONFIG } from '../../../utils/config';
import { getOntotisDropDown } from '../../../utils/apicall/commonApi';
import { useNavigate } from 'react-router-dom';
import PersonList from '../person/personList';

interface SubOntotitaListProps {
  data?: Person[];
  fromid?: string;
  canedit?:boolean;
}


const SectionPersonOntotitaList: React.FC<SubOntotitaListProps> = ({ data = [],fromid, canedit }) => {
  const navigate = useNavigate();
  const handleAddClick = ()  => {
    
    navigate(CONFIG.urls.getPersonsAddUrl_Admin(), {
      state: { returnTo: CONFIG.urls.getOntotitaViewUrl_Admin(fromid!), id: fromid?.toString() },
    });
  };

  return (
    <div>
      <section className="sub-services py-5">
        <div className="container bg-white rounded-4 p-5">
             {/* ADD */}
             <div className="row align-items-center">
              {/* Heading */}
              <div className="col-md-9 ">
                <h2 className="h5 mb-4 text-secondary">Προσωπικό</h2>
              </div>

              {/* Button aligned right */}
              <div className="col-md-3 text-md-end p-2">
                <button className="btn btn-success btn-sm mb-4" onClick={() => handleAddClick()}>
                  <i className="bi bi-plus me-1"></i> Προσθήκη
                </button>
              </div>
            </div>
          
      
          {data.length === 0 ? (
            <p className="text-center text-muted">Δεν υπάρχουν πληροφορίες</p>
          ) : (
               
       <PersonList data={data} from={'ontotis'} fromid={fromid} canedit={canedit}/>
      )}
      </div>
      </section>
    </div>
  );
};

export default SectionPersonOntotitaList;
